import axiosClient from "utils/api/axios-client";

const flashSaleApi = {
  getTimes: (params) => {
    const url = "/api/v1/flashsales/times";
    return axiosClient.get(url, { params });
  },
  getByCode: (code) => {
    const url = `/api/v1/flashsales/${code}`;
    return axiosClient.get(url);
  },
  update: (id, data) => {
    const url = `/api/v1/flashsales/${id}`;
    return axiosClient.put(url, data);
  },
  // Dish CRUD operations
  createDish: (flashSaleId, data) => {
    const url = `/api/v1/flashsales/${flashSaleId}/dishes`;
    return axiosClient.post(url, data);
  },
  updateDish: (flashSaleId, dishId, data) => {
    const url = `/api/v1/flashsales/${flashSaleId}/dishes/${dishId}`;
    return axiosClient.put(url, data);
  },
  deleteDish: (flashSaleId, dishId) => {
    const url = `/api/v1/flashsales/${flashSaleId}/dishes/${dishId}`;
    return axiosClient.delete(url);
  },
  // Flash Sale Register operations
  getRegisters: (params) => {
    const url = "/api/v1/flashsale-registers";
    return axiosClient.get(url, { params });
  },
  updateProcessed: (id, processed) => {
    const url = `/api/v1/flashsale-registers/${id}/processed`;
    return axiosClient.patch(url, { processed });
  },
  deleteRegister: (id) => {
    const url = `/api/v1/flashsale-registers/${id}`;
    return axiosClient.delete(url);
  },
};

export default flashSaleApi;
